module.exports = __webpack_public_path__ + "static/img/5.c0ad880.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/sp/5.png
// module id = lHPE
// module chunks = 0